import React from 'react';

import AppBar from './AppBar';

import './BaseLayout.scss';
import { Outlet } from 'react-router-dom';

const BaseLayout: React.FC = () => {
  return (
    <div className="base-layout-root">
      <div className="font-preload font-preload-light">font preload</div>
      <AppBar />
      <div className="layout-container">
        <Outlet />
        {/* <MainPage /> */}
      </div>
    </div>
  );
};

export default BaseLayout;
